import { defineEvent } from "@visioni/a3s-analytics";
import type { CameraScope } from "@src/features/cameras/analytics";
import type { CameraLevel } from "@src/features/alarms/analytics";
import type { RequestErrorType } from "@src/services/api/error-type";
import type { AlarmRoutine } from "@src/services/api/types";

// The AI schedule assistant (`AgentScreenContent`): the `/agent` route (native and web)
// and the embedded side panel (web). Every event names the camera it advises on.

export const AiAgentEntered = defineEvent<CameraScope>("AI Agent Entered");

/** The user's message is never sent, only its length. */
export const AiAgentMessageSent = defineEvent<CameraScope & { message_length: number }>("AI Agent Message Sent");

/**
 * `routine_kind` is set for a routine preview. An exception preview sends no exception id:
 * ids of exceptions made at site level embed the exception's free-text reason.
 */
export const AiAgentPreviewClicked = defineEvent<
  CameraScope & {
    preview_type: "response" | "routine" | "exception";
    routine_kind?: AlarmRoutine["kind"];
  }
>("AI Agent Preview Clicked");

export const AiAgentApplyAllClicked = defineEvent<
  CameraScope & { has_response: boolean; has_routine: boolean; exceptions_count: number }
>("AI Agent Apply All Clicked");

/**
 * "Apply all" saved the proposed settings in one request (`useUpdateAlarmSettings`).
 * Not an `Alarm * Saved` event: one apply would count as up to three saves.
 */
type AppliedChanges = CameraLevel & { has_response: boolean; has_routine: boolean; exceptions_count: number };
export const AiAgentChangesApplied = defineEvent<AppliedChanges>("AI Agent Changes Applied");
export const AiAgentChangesApplyFailed = defineEvent<AppliedChanges & { error_type: RequestErrorType }>(
  "AI Agent Changes Apply Failed",
);
